// Fetch list

export const FETCH = 'companyBankAccounts.FETCH'
export const FETCH_STARTED = 'companyBankAccounts.FETCH_STARTED'
export const FETCH_FULFILLED = 'companyBankAccounts.FETCH_FULFILLED'
export const FETCH_REJECTED = 'companyBankAccounts.FETCH_REJECTED'
export const FETCH_CANCELLED = 'companyBankAccounts.FETCH_CANCELLED'

export const SORTING_CHANGED = 'companyBankAccounts.SORTING_CHANGED'

// Fetch one

export const FETCH_ONE = 'companyBankAccounts.FETCH_ONE'
export const FETCH_ONE_STARTED = 'companyBankAccounts.FETCH_ONE_STARTED'
export const FETCH_ONE_FULFILLED = 'companyBankAccounts.FETCH_ONE_FULFILLED'
export const FETCH_ONE_REJECTED = 'companyBankAccounts.FETCH_ONE_REJECTED'
export const FETCH_ONE_CANCELLED = 'companyBankAccounts.FETCH_ONE_CANCELLED'

// Save

export const SAVE = 'companyBankAccounts.SAVE'
export const SAVE_STARTED = 'companyBankAccounts.SAVE_STARTED'
export const SAVE_FULFILLED = 'companyBankAccounts.SAVE_FULFILLED'
export const SAVE_REJECTED = 'companyBankAccounts.SAVE_REJECTED'
export const SAVE_CANCELLED = 'companyBankAccounts.SAVE_CANCELLED'

// Delete

export const DELETE = 'companyBankAccounts.DELETE'
export const DELETE_STARTED = 'companyBankAccounts.DELETE_STARTED'
export const DELETE_FULFILLED = 'companyBankAccounts.DELETE_FULFILLED'
export const DELETE_REJECTED = 'companyBankAccounts.DELETE_REJECTED'
export const DELETE_CANCELLED = 'companyBankAccounts.DELETE_CANCELLED'

// Export

export const EXPORT = 'companyBankAccounts.EXPORT'
export const EXPORT_FULFILLED = 'companyBankAccounts.EXPORT_FULFILLED'
